export default __webpack_public_path__ + "static/media/login.04b6b2f6.svg";